import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialUserState = {
  status: STATUS.IDLE,
  loadCustomDomainIndicatorStatus: STATUS.IDLE,
  updateCustomDomainIndicatorStatus: STATUS.IDLE,
  deleteCustomDomainIndicatorStatus: STATUS.IDLE,
  photoUploadStatus: STATUS.IDLE,
  userPreferencesStatus: STATUS.IDLE,
  updateStatus: STATUS.IDLE,
  usersStatus: STATUS.IDLE,
  mySubscriptionPlanStatus: STATUS.IDLE,
  setOrganizationActiveStatus: STATUS.IDLE,
  setOrganizationInactiveStatus: STATUS.IDLE,
  error: null,
  user: null,
  users: [],
  organisation_users_info: [],
  organization: null,
  userPreferences: {},
  customGeoIPOrganisationUUID: null,
  customGeoIpCount: null,
  customIPRangeIndicators: null,
  customGeoIPList: null,
  customDomainIndicators: [],
  companyDomainIndicators: [],
  brandDomainIndicators: [],
  supplyDomainIndicators: [],
  mySubscriptionPlan: [],
  setOrganizationActiveData: [],
  setOrganizationInactiveData: [],
  websocketConnection: null,
  websocketConnectionStatus: STATUS.IDLE,
};

export default (state = initialUserState, action) => {
  switch (action?.type) {
    case types.LOAD_MY_SUBSCRIPTION_PLAN: {
      return {
        ...state,
        mySubscriptionPlanStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_MY_SUBSCRIPTION_PLAN): {
      return {
        ...state,
        mySubscriptionPlan: action?.payload,
        mySubscriptionPlanStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_MY_SUBSCRIPTION_PLAN):
      return {
        ...state,
        error: true,
        mySubscriptionPlanStatus: STATUS.ERROR,
      };
    case types.LOAD_MY_SUBSCRIPTION_LIMIT: {
      return {
        ...state,
        mySubscriptionLimitStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_MY_SUBSCRIPTION_LIMIT): {
      return {
        ...state,
        mySubscriptionLimit: action?.payload?.total_requests_left,
        mySubscriptionLimitStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_MY_SUBSCRIPTION_LIMIT):
      return {
        ...state,
        error: true,
        mySubscriptionLimitStatus: STATUS.ERROR,
      };

    case types.INVITE_USER:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.INVITE_USER):
      return {
        ...state,
        status: STATUS.LOADED,
      };
    case reject(types.LOAD_CUSTOM_GEO_IP):
      return {
        ...state,
        status: STATUS.ERROR,
      };
    case types.LOAD_USER:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_USER):
      return {
        ...state,
        user: action?.payload?.user,
        customGeoIPOrganisationUUID: null,
        // organization: action?.payload?.organization,
        status: STATUS.LOADED,
      };
    case reject(types.LOAD_USER):
      return {
        ...state,
        error: true,
        status: STATUS.ERROR,
      };

    case types.LOAD_ORGANIZATION:
      return {
        ...state,
        //status: STATUS.LOADING,
      };
    case resolve(types.LOAD_ORGANIZATION):
      return {
        ...state,
        organization: action?.payload?.organization,
        // customGeoIPOrganisationUUID: null,
        // organization: action?.payload?.organization,
        //status: STATUS.LOADED,
      };
    case reject(types.LOAD_ORGANIZATION):
      return {
        ...state,
        error: true,
        //status: STATUS.ERROR,
      };

    case types.CHANGE_PASSWORD:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.CHANGE_PASSWORD):
      return {
        ...state,
        status: STATUS.LOADED,
      };
    case reject(types.CHANGE_PASSWORD):
      return {
        ...state,
        error: true,
        status: STATUS.ERROR,
      };
    case types.UPLOAD_PHOTO:
      return {
        ...state,
        photoUploadStatus: STATUS.LOADING,
      };
    case resolve(types.UPLOAD_PHOTO):
      return {
        ...state,
        photoUploadStatus: STATUS.LOADED,
        photoUploadData: action?.payload?.photo,
      };
    case reject(types.UPLOAD_PHOTO):
      return {
        ...state,
        error: true,
        photoUploadStatus: STATUS.ERROR,
      };
    case types.LOAD_CUSTOM_IP_RANGE_INDICATORS:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_CUSTOM_IP_RANGE_INDICATORS):
      return {
        ...state,
        customIPRangeIndicators: action?.payload?.results,
        status: STATUS.LOADED,
      };
    case reject(types.LOAD_CUSTOM_IP_RANGE_INDICATORS):
      return {
        ...state,
        status: STATUS.ERROR,
      };

    case types.SET_CUSTOM_IP_RANGE_INDICATOR:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.SET_CUSTOM_IP_RANGE_INDICATOR):
      return {
        ...state,
        customIPRangeIndicatorStart: action?.payload?.ip_range_start,
        customIPRangeIndicatorEnd: action?.payload?.ip_range_end,
        status: STATUS.LOADED,
      };
    case reject(types.SET_CUSTOM_IP_RANGE_INDICATOR):
      return {
        ...state,
        status: STATUS.ERROR,
      };

    case types.LOAD_CUSTOM_DOMAIN_INDICATORS:
      return {
        ...state,
        loadCustomDomainIndicatorStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_CUSTOM_DOMAIN_INDICATORS):
      return {
        ...state,
        customDomainIndicators: action?.payload?.results,
        companyDomainIndicators: action?.payload?.results
          ?.filter((el) => el?.domain_type === 'company')
          ?.map((e) => e?.domain)
          ?.join(','),
        brandDomainIndicators: action?.payload?.results
          ?.filter((el) => el?.domain_type === 'brand')
          ?.map((e) => e?.domain)
          ?.join(','),
        supplyDomainIndicators: action?.payload?.results
          ?.filter((el) => el?.domain_type === 'supply')
          ?.map((e) => e?.domain)
          ?.join(','),
        loadCustomDomainIndicatorStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_CUSTOM_DOMAIN_INDICATORS):
      return {
        ...state,
        loadCustomDomainIndicatorStatus: STATUS.ERROR,
      };

    case types.SET_CUSTOM_DOMAIN_INDICATORS:
      return {
        ...state,
        updateCustomDomainIndicatorStatus: STATUS.LOADING,
      };
    case resolve(types.SET_CUSTOM_DOMAIN_INDICATORS):
      return {
        ...state,
        customDomainIndicators: [
          ...state?.customDomainIndicators,
          action?.payload,
        ],
        companyDomainIndicators: [
          ...state?.customDomainIndicators,
          action?.payload,
        ]
          ?.filter((el) => el?.domain_type === 'company')
          ?.map((e) => e?.domain)
          ?.join(','),
        brandDomainIndicators: [
          ...state?.customDomainIndicators,
          action?.payload,
        ]
          ?.filter((el) => el?.domain_type === 'brand')
          ?.map((e) => e?.domain)
          ?.join(','),
        supplyDomainIndicators: [
          ...state?.customDomainIndicators,
          action?.payload,
        ]
          ?.filter((el) => el?.domain_type === 'supply')
          ?.map((e) => e?.domain)
          ?.join(','),
        updateCustomDomainIndicatorStatus: STATUS.LOADED,
      };
    case reject(types.SET_CUSTOM_DOMAIN_INDICATORS):
      return {
        ...state,
        updateCustomDomainIndicatorStatus: STATUS.ERROR,
      };

    case types.DELETE_CUSTOM_DOMAIN_INDICATORS:
      return {
        ...state,
        deleteCustomDomainIndicatorStatus: STATUS.LOADING,
      };
    case resolve(types.DELETE_CUSTOM_DOMAIN_INDICATORS):
      const newCustomDomainIndicators = [
        ...state?.customDomainIndicators,
      ]?.filter((el) => el?.uuid !== action?.payload);

      return {
        ...state,
        customDomainIndicators: newCustomDomainIndicators,
        companyDomainIndicators: newCustomDomainIndicators
          ?.filter((el) => el?.domain_type === 'company')
          ?.map((e) => e?.domain)
          ?.join(','),
        brandDomainIndicators: newCustomDomainIndicators
          ?.filter((el) => el?.domain_type === 'brand')
          ?.map((e) => e?.domain)
          ?.join(','),
        supplyDomainIndicators: newCustomDomainIndicators
          ?.filter((el) => el?.domain_type === 'supply')
          ?.map((e) => e?.domain)
          ?.join(','),
        deleteCustomDomainIndicatorStatus: STATUS.LOADED,
      };
    case reject(types.DELETE_CUSTOM_DOMAIN_INDICATORS):
      return {
        ...state,
        deleteCustomDomainIndicatorStatus: STATUS.ERROR,
      };

    case types.LOAD_CUSTOM_GEO_IP_ORGANISATION:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_CUSTOM_GEO_IP_ORGANISATION):
      if (action?.payload?.uuid) {
        return {
          ...state,
          customGeoIPOrganisationUUID: action?.payload?.uuid,
          customGeoIpCount: action?.payload?.geo_ip_list?.length,
          status: STATUS.LOADED,
        };
      } else {
        return {
          ...state,
          customGeoIPOrganisationUUID: action?.payload?.results[0]?.uuid,
          customGeoIpCount: action?.payload?.count,
          status: STATUS.LOADED,
        };
      }

    case reject(types.LOAD_CUSTOM_GEO_IP_ORGANISATION):
      return {
        ...state,
        status: STATUS.ERROR,
      };

    case types.LOAD_CUSTOM_GEO_IP:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_CUSTOM_GEO_IP):
      return {
        ...state,
        customGeoIPList: action?.payload?.geo_ip_list,
        status: STATUS.LOADED,
      };
    case reject(types.LOAD_CUSTOM_GEO_IP):
      return {
        ...state,
        status: STATUS.ERROR,
      };

    case types.SET_CUSTOM_GEO_IP:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.SET_CUSTOM_GEO_IP):
      return {
        ...state,
        customGeoIPList: action?.payload?.geo_ip_list,
        status: STATUS.LOADED,
      };
    case reject(types.SET_CUSTOM_GEO_IP):
      return {
        ...state,
        status: STATUS.ERROR,
      };

    case types.UPDATE_USER_PROFILE:
    case types.UPDATE_USER_ORGANIZATION:
      return {
        ...state,
        updateStatus: STATUS.RUNNING,
      };
    case resolve(types.UPDATE_USER_PROFILE):
      return {
        ...state,
        user: action?.payload,
        updateStatus: STATUS.SUCCESS,
      };
    case resolve(types.UPDATE_USER_ORGANIZATION):
      return {
        ...state,
        organization: action?.payload,
        updateStatus: STATUS.SUCCESS,
      };
    case reject(types.UPDATE_USER_PROFILE):
    case reject(types.UPDATE_USER_ORGANIZATION):
      return {
        ...state,
        error: true,
        updateStatus: STATUS.ERROR,
      };

    case types.LOAD_USER_PREFERENCES:
      return {
        ...state,
        userPreferencesStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_USER_PREFERENCES):
      return {
        ...state,
        userPreferences: action?.payload,
        userPreferencesStatus: STATUS.LOADED,
      };
    case reject(types.LOAD_USER_PREFERENCES):
      return {
        ...state,
        error: true,
        userPreferencesStatus: STATUS.ERROR,
      };

    case types.UPDATE_USER_PREFERENCES:
      return {
        ...state,
        updateStatus: STATUS.RUNNING,
      };
    case resolve(types.UPDATE_USER_PREFERENCES):
      return {
        ...state,
        userPreferences: action?.payload,
        updateStatus: STATUS.SUCCESS,
      };
    case reject(types.UPDATE_USER_PREFERENCES):
      return {
        ...state,
        error: true,
        updateStatus: STATUS.ERROR,
      };
    case types.LOAD_USERS:
      return {
        ...state,
        usersStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_USERS):
      return {
        ...state,
        users: action?.payload?.results,
        usersStatus: STATUS.LOADED,
      };
    case types.LOAD_USERS_INFO:
      return {
        ...state,
      };
    case resolve(types.LOAD_USERS_INFO):
      return {
        ...state,
        organisation_users_info: action?.payload,
      };
    case resolve(types.CREATE_USER):
      return {
        ...state,
        users: state?.users?.concat(action?.payload),
      };
    case resolve(types.DELETE_USER):
      return {
        ...state,
        users: state?.users?.filter((u) => u?.username !== action?.id),
      };
    case resolve(types.UPDATE_USER):
      const { users } = state;
      const index = users?.findIndex(
        (user) => user?.username === action?.payload?.username,
      );
      return {
        ...state,
        users: [
          ...users?.slice(0, index),
          action?.payload,
          ...users?.slice(index + 1),
        ],
      };

    case types.RESET_SET_ORGANIZATION_ACTIVE_STATUS: {
      return {
        ...state,
        setOrganizationActiveData: [],
        setOrganizationActiveStatus: STATUS.IDLE,
      };
    }
    case types.SET_ORGANIZATION_ACTIVE: {
      return {
        ...state,
        setOrganizationActiveStatus: STATUS.LOADING,
      };
    }
    case resolve(types.SET_ORGANIZATION_ACTIVE): {
      return {
        ...state,
        setOrganizationActiveData: action?.payload,
        setOrganizationActiveStatus: STATUS.LOADED,
      };
    }
    case reject(types.SET_ORGANIZATION_ACTIVE):
      return {
        ...state,
        error: true,
        setOrganizationActiveStatus: STATUS.ERROR,
      };

    case types.RESET_SET_ORGANIZATION_INACTIVE_STATUS: {
      return {
        ...state,
        setOrganizationInactiveData: [],
        setOrganizationInactiveStatus: STATUS.IDLE,
      };
    }
    case types.SET_ORGANIZATION_INACTIVE: {
      return {
        ...state,
        setOrganizationInactiveStatus: STATUS.LOADING,
      };
    }
    case resolve(types.SET_ORGANIZATION_INACTIVE): {
      return {
        ...state,
        setOrganizationInactiveData: action?.payload,
        setOrganizationInactiveStatus: STATUS.LOADED,
      };
    }
    case reject(types.SET_ORGANIZATION_INACTIVE):
      return {
        ...state,
        error: true,
        setOrganizationInactiveStatus: STATUS.ERROR,
      };
    case resolve(types.SET_WEBSOCKET_CONNECTION_STATUS): {
      return {
        ...state,
        websocketConnectionStatus: action?.payload,
      };
    }
    case resolve(types.SET_WEBSOCKET_CONNECTION): {
      return {
        ...state,
        websocketConnection: action?.payload,
      };
    }

    default:
      return state;
  }
};
